/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48497Item {
  
  /** 战役项目编号 */
  projectNo?: string;
  
  /** 战役项目名 */
  name?: string;
  
  /** 项目Logo */
  logo?: string;
  
  /** 项目级别1:超S级2:S级3:A级4:B级 */
  level?: number;
  
  /** 项目周期：1:成熟2:孵化3:筹备 */
  growStatus?: number;
  
  /** 负责人信息 ,UserResp */
  master?: any;
  
  /** 项目状态（1：正常；2：风险；3：失控） */
  status?: number;
  
  /** 项目进度 ,ProjectProgressResp */
  progress?: any;
  
  /** 当前里程碑 */
  milestone?: string;
  
  /** 里程碑截止日期 */
  milestoneTime?: any;
  
  /** 项目开始日期 */
  projectStartDate?: any;
  
  /** 项目结束日期 */
  projectEndDate?: any;
  
  /** 当前里程碑说明,(已过期N天) */
  milestoneTimeDesc?: string;
  
  /** 项目描述 */
  desc?: string;
  
  /** 项目负责人编号 */
  projectLeaderNo?: string;
  
  /** 项目负责人名称 */
  projectLeaderName?: string;
  
  /** 项目进度（61.23%存6123） */
  projectProgress?: number;
  
  /** 时间进度（61.23%存6123） */
  timeProgress?: number;
  
  /** 是否长期：0.非长期(默认)1.长期 */
  isLongTime?: number;
  
  /** 项目负责人真实名称 */
  projectLeaderRealName?: string;
  
  /** 项目负责人头像 */
  projectLeaderAvatar?: string;
  
  /** 业务分类：1.基础业务2.创新业务3.投资业务 */
  businessType?: number;
  
  /** 类型：1.项目(默认)2.任务 */
  projectType?: number;
  
  /** 当前项目的主业务,默认0 */
  parentProjectNo?: string;
  
  /** 健康标志：0-10 */
  healthFlag?: number;
  
  /** 汇报提醒--时分 */
  reportRemindTime?: string;
  
  /** 汇报提醒--周 */
  reportRemindWeek?: string;
  
  /** 启用状态：1.启用2.停用 */
  enableStatus?: number;
  
};
    
  



export interface API48497Req {
  
  /** 项目名称（左右去空格模糊查询） */
  name?: string;
    
  /** 项目级别1:超S级2:S级3:A级4:B级,支持多选 */
  levelList?: string;
    
  /** 项目周期：1:成熟2:孵化3:筹备,支持多选 */
  growStatusList?: string;
    
  /** 项目状态（1：正常；2：风险；3：失控）,支持多选 */
  statusList?: string;
    
  /** 业务分类：1.基础业务2.创新业务3.投资业务 */
  businessType?: string;
    
  /** 业务分类：1.基础业务2.创新业务3.投资业务 */
  businessTypeList?: string;
    
  /** 类型：1.项目(默认)2.任务 */
  projectType?: string;
    
  /** 启用状态：1.启用2.停用 */
  enableStatus?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API48497Res {
  /** T  */
  list?: API48497Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 48497 获取项目列表--列表模式

export interface IUseGetAPI48497Return {
  /** 获取项目列表--列表模式: 接口请求状态 */
  isAPI48497Loading: boolean;
  /** 获取项目列表--列表模式: 接口请求返回数据 */
  dataAPI48497: API48497Res;
  /**  获取项目列表--列表模式: 接口数据请求方法 */
  fetchAPI48497Data:  (inputs: API48497Req, config?: YWRequestConfig) => Promise<API48497Res>;
  /** 获取项目列表--列表模式: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48497 = ():IUseGetAPI48497Return => {
  let isMount = true;
  const [isAPI48497Loading, setIsAPI48497Loading] = useState(false);
  const [dataAPI48497, setDataAPI48497] = useState<API48497Res>({} as API48497Res);
  const requestUrl = `${basePath}/corp-admin/project/list/v1`;

  const fetchAPI48497Data = async (inputs: API48497Req, config?: YWRequestConfig): Promise<API48497Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48497Req>) || {}) as API48497Req;
    
  
    if ( isMount ) {
      setIsAPI48497Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48497Res>(`${basePath}/corp-admin/project/list/v1?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48497(res || {} as API48497Res);
        setIsAPI48497Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48497Loading(false);
      }
      return false as unknown as API48497Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48497Loading,
    dataAPI48497,
    fetchAPI48497Data,
    requestUrl,
  }
}

